module.exports = "<app-header show-fino-logo=\"true\"></app-header>\n\n<div class=\"changelog\">\n  <div class=\"content-wrapper\">\n    <h1 class=\"changelog-title\">Changelog</h1>\n\n    <div ng-repeat=\"changelog in vm.changelogs\" class=\"panel panel-default\">\n      <div class=\"panel-body\">\n        <div class=\"content\" markdown-to-html=\"changelog\"></div>\n      </div>\n    </div>\n\n    <div ng-if=\"vm.errorMessage\" class=\"alert alert-danger\" role=\"alert\">\n      {{ vm.errorMessage }}\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/changelog/changelog.html
// module id = 1579
// module chunks = 0